<template>
  <svg id="icono-editar" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 40 40">
    <rect id="Rectángulo_724" data-name="Rectángulo 724" :width="width" :height="height" fill="none"/>
    <g id="Icon_feather-edit" data-name="Icon feather-edit" transform="translate(5 3.182)">
      <path id="Trazado_7338" data-name="Trazado 7338" d="M14.629,6H5.584A2.584,2.584,0,0,0,3,8.584v18.09a2.584,2.584,0,0,0,2.584,2.584h18.09a2.584,2.584,0,0,0,2.584-2.584V17.629" transform="translate(0 -0.441)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <path id="Trazado_7339" data-name="Trazado 7339" d="M25.568,3.621A2.741,2.741,0,0,1,29.444,7.5L17.169,19.773,12,21.065,13.292,15.9Z" transform="translate(-1.247 0)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#5a6b8e'
    },
    height: String,
    width: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/EditIcon.vue